<template>
  <span>
    <el-button @click="sortClick">规格值排序</el-button>
    <el-dialog title="拖动规格值进行排序" :visible.sync="dialogVisible" width="800px" @close="handleClose">
      <div class="sort-container">
        <div v-for="(spec, specIndex) in localSpecifications" :key="spec.nameKey" class="spec-group">
          <div class="spec-title">{{ spec.name }}：</div>
          <vue-draggable
            v-model="spec.values"
            class="draggable-list"
            handle=".spec-value-item"
            :group="{ name: `spec-${specIndex}`, pull: false, put: false }"
            :animation="500"
          >
            <div
              v-for="(value, valueIndex) in spec.values"
              :key="valueIndex"
              class="spec-value-item"
              :title="value.value || value.name || value"
            >
              <!-- <drag-item-content class="drag-handle"></drag-item-content> -->
              <span class="value-text">{{ value.value || value.name || value }}</span>
            </div>
          </vue-draggable>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { dragItemMixin } from '../../utils/mixins';
import { cloneDeep } from 'lodash';

export default {
  name: 'SpecsValuesSort',
  props: {
    specifications: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [dragItemMixin],
  data() {
    return {
      dialogVisible: false,
      localSpecifications: [], // 本地规格数据副本
    };
  },

  methods: {
    sortClick(opts = {}) {
      // 创建规格数据的深拷贝，避免直接修改原数据
      this.localSpecifications = cloneDeep(this.specifications);
      this.dialogVisible = true;
    },

    onDragEnd(evt) {
      // 拖拽结束事件，可以在这里添加额外的处理逻辑
      console.log('拖拽完成:', evt);
    },

    sure() {
      // 确认排序，将本地数据同步回父组件
      this.$emit('update:specifications', this.localSpecifications);
      this.handleClose();
    },

    handleClose() {
      this.dialogVisible = false;
      this.localSpecifications = [];
    },
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.sort-container {
  max-height: 400px;
  overflow-y: auto;
}

.spec-group {
  margin-bottom: 20px;

  .spec-title {
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
    font-size: 14px;
  }
}

.draggable-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.spec-value-item {
  display: flex;
  align-items: center;
  padding: 4px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  cursor: move;
  transition: all 0.3s;
  width: 130px; /* 固定宽度 */
  box-sizing: border-box;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
  }

  .drag-handle {
    margin-right: 8px;
    flex-shrink: 0; /* 防止拖拽图标被压缩 */
  }

  .value-text {
    flex: 1;
    font-size: 12px;
    color: #606266;
    overflow: hidden; /* 隐藏溢出内容 */
    text-overflow: ellipsis; /* 显示省略号 */
    white-space: nowrap; /* 不换行 */
    min-width: 0; /* 确保文本可以被压缩 */
  }
}

// 拖拽时的样式
.ghost {
  opacity: 0.5;
  background-color: #f0f9ff;
}

.chosen {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}
</style>